import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import MaterialIcon from '../../common/components/MaterialIcon';

// 用 mithril 自带的 route Link（SPA 导航），避免依赖 core 外部模块解析
const MLink = m.route.Link;

// 内联文案（自定义 UI 不依赖扩展语言资产）
const STR = {
  'zh-Hans': {
    title: '十大热帖',
    empty: '今天还很安静，来发第一帖吧',
    replies: n => `今日 ${n} 回复`
  },
  en: {
    title: 'Top 10 today',
    empty: "It's quiet today. Start the first discussion!",
    replies: n => `${n} replies today`
  }
};
const t = (k, arg) => {
  const locale = app.translator && app.translator.locale || 'zh-Hans';
  const pack = STR[locale] || STR['zh-Hans'];
  const v = pack[k] ?? STR['zh-Hans'][k];
  return typeof v === 'function' ? v(arg) : v;
};

/**
 * 十大热帖：按今日回复数取前 10，悬停显示所属版面。
 */
export default class HotDiscussions extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.items = [];
    this.loading = true;
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    try {
      this.load();
    } catch (e) {
      this.loading = false;
      this.items = [];
    }
  }
  load() {
    app.request({
      method: 'GET',
      url: `${app.forum.attribute('apiUrl')}/kapok-hot-discussions`,
      deserialize: JSON.parse
    }).then(res => {
      this.items = res && res.items || [];
    }).catch(() => {
      this.items = [];
    }).then(() => {
      this.loading = false;
      // 推迟到下一个 tick，避免在首次 mount 期间重入 mithril 导致整棵树损坏
      setTimeout(() => m.redraw(), 0);
    });
  }
  view() {
    // 兜底：任何渲染异常都不能打断整棵树的 mount
    try {
      return this.renderInner();
    } catch (e) {
      return m("div", {
        className: "KapokHot"
      }, "\u2026");
    }
  }
  renderInner() {
    return m("div", {
      className: "KapokHot"
    }, m("h3", {
      className: "KapokHot-title"
    }, m(MaterialIcon, {
      name: "whatshot"
    }), " ", t('title')), this.loading ? m("div", {
      className: "KapokHot-empty"
    }, "\u2026") : this.items.length ? m("ol", {
      className: "KapokHot-list"
    }, this.items.map((d, i) => m("li", {
      key: d.id,
      className: "KapokHot-item",
      title: d.tag ? d.tag.name : ''
    }, m("span", {
      className: `KapokHot-rank KapokHot-rank--${i < 3 ? 'top' : 'normal'}`
    }, i + 1), m(MLink, {
      className: "KapokHot-link",
      href: `/d/${d.id}-${d.slug}`
    }, d.title), d.tag ? m("span", {
      className: "KapokHot-tag",
      style: d.tag.color ? `--tagcolor:${d.tag.color}` : ''
    }, d.tag.name) : null, m("span", {
      className: "KapokHot-count"
    }, t('replies', d.repliesToday))))) : m("div", {
      className: "KapokHot-empty"
    }, t('empty')));
  }
}
flarum.reg.add('kapok-plus-site', 'forum/components/HotDiscussions', HotDiscussions);